import { DeleteOutlined, HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Col, Form, Row, Select } from 'antd';
import React from 'react';
import AddText from './AddText';
import GetAttribute from './GetAttribute';
import SelectMedia from './SelectMedia';

const ValuesListSortable = ({
  id,
  item,
  onTypeChange,
  onValueChange,
  onDelete,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    marginBottom: 16,
    background: isDragging ? '#d9d9d9' : '#fff',
    border: '1px solid #d9d9d9',
    borderRadius: '8px',
    padding: '8px',
    position: 'relative',
    zIndex: isDragging ? 999 : 'auto',
  };

  const getFormForElement = (item, id, onValueChange) => {
    switch (item.type) {
      case 'attribute':
        return (
          <GetAttribute
            value={item.value}
            onChange={(value) => onValueChange(id, value)}
            fieldNamePrefix={['list', id]}
          />
        );
      case 'freetext':
        return (
          <AddText
            value={item.value}
            onChange={(value) => onValueChange(id, value)}
            fieldNamePrefix={['list', id]}
          />
        );
      case 'media':
        return (
          <SelectMedia
            value={item.value}
            onChange={(value) => onValueChange(id, value)}
            fieldNamePrefix={['list', id]}
          />
        );
      default:
        return null;
    }
  };

  const formElements = getFormForElement(item, id, onValueChange);

  return (
    <div ref={setNodeRef} style={style}>
      <Row gutter={16} align="middle">
        <Col
          span={1}
          style={{
            textAlign: 'center',
            cursor: 'grab',
          }}
        >
          <HolderOutlined
            {...attributes}
            {...listeners}
            style={{ fontSize: '18px', color: '#999', cursor: 'inherit' }}
            onMouseDown={(e) => (e.target.style.cursor = 'grabbing')}
            onMouseUp={(e) => (e.target.style.cursor = 'grab')}
          />
        </Col>
        <Col span={6}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Form.Item
              label="Type"
              name={[id, 'type']}
              initialValue={item.type}
            >
              <Select
                onChange={(value) => onTypeChange(id, value)}
                options={[
                  { label: 'Champ', value: 'attribute' },
                  { label: 'Texte libre', value: 'freetext' },
                  { label: 'Média', value: 'media' },
                ]}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
        </Col>
        <Col span={16}>{formElements}</Col>
        <Col span={1} style={{ textAlign: 'center' }}>
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(id)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ValuesListSortable;
